import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';

const CalendarCallback: React.FC = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState<string>('Connecting your calendar…');

  const redirectUri = useMemo(() => `${window.location.origin}/auth/google/callback`, []);

  useEffect(() => {
    const code = params.get('code');
    if (!code) {
      setStatus('error');
      setMessage('Missing authorization code.');
      return;
    }

    (async () => {
      try {
        await api.completeCalendarAuthorization(code, redirectUri);
        setStatus('success');
        setMessage('Calendar connected successfully. Redirecting…');
        setTimeout(() => navigate('/connect-fub'), 1200);
      } catch (e: any) {
        setStatus('error');
        setMessage(e?.response?.data?.message || e?.message || 'Failed to complete authorization');
      }
    })();
  }, [params, redirectUri, navigate]);

  return (
    <div className="min-h-screen bg-lightestGray flex items-center justify-center">
      <div className="p-6 border border-lighterGray bg-white rounded-2xl shadow-md w-[480px] text-center">
        <div className="text-h2 font-semibold text-darkestSlate mb-2">Google Calendar</div>
        <div className={`text-h4 ${status === 'error' ? 'text-red-600' : 'text-darkGray'}`}>{message}</div>
        {status === 'loading' && <div className="mt-3 text-darkGray">Please wait…</div>}
        {status !== 'loading' && (
          <button onClick={() => navigate('/connect-fub')} className="mt-4 px-4 py-2 bg-darkBlue text-white rounded-lg">Continue</button>
        )}
      </div>
    </div>
  );
};

export default CalendarCallback;


